var FormFieldFileUpload = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

FormFieldFileUpload.prototype.init = function(){

	var self = this;

	this.options.$el.find('input[type="file"]').change(function(){

		var files = $(this).prop("files");

		var filenames = $.map(files, function(val) { return val.name; }).join(', ');

		self.options.$el.find(".documents").text(filenames);

	});

};

export default  FormFieldFileUpload;
